import * as Yup from 'yup'

export const AdminValidationSchema = Yup.object({
  email: Yup.string().required(),
  userName: Yup.string().required().matches(/^\S*$/, "Username may not contain spaces"),
  firstName: Yup.string().required(),
  lastName: Yup.string().optional(),
  lastNamePrefix: Yup.string().optional(),
})